<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div
  class="photo"
  cdkDragHandle
  [style.width.px]="width"
  [style.height.px]="height"
  [style.backgroundImage]="image ? 'url(' + image + ')' : null"
  [class.selected]="checked"
>
  <div class="flex photo-content jcsb" [id]="id + '-checkbox'" (click)="checkedChanged()">
    <rx-row class="flex-nosize jcfe" *ngIf="!checked">
      <div class="action-controls flex flex-row flex-nosize" *ngIf="showMenuHandle">
        <div>
          <div *ngIf="counter" class="controls-counter">{{ counter }}</div>
        </div>
        <rx-icon
          (click)="onMenuClicked($event)"
          *ngIf="showMenuHandle"
          [id]="id + '-menu'"
          name="icon-shadow-menu"
          class="rel z1 cp"
          [matMenuTriggerFor]="actionMenu"
          [matMenuTriggerData]="actionMenuContext"
        ></rx-icon>
      </div>
    </rx-row>

    <div class="flex flex-row jcc aic check-control" *ngIf="checked">
      <rx-icon class="icon-check" name="icon-check"></rx-icon>
      &nbsp;
    </div>

    <div class="description">
      {{ description }}
    </div>
  </div>
</div>
